import React = require('react');
import ReactDOM = require('react-dom');
import { SharedCompUserList, IUserItem } from './SharedCompUserList';
import Ajax from '../../lib/Ajax';
import { IEventForList } from '../../../interfaces/models/IEvent';
import { Tools } from '../../lib/Tools';

interface IMyInvitationsProps {

}

interface IMyInvitationsState {
    items:Array<IUserItem>
}

class MyInvitations extends React.Component<IMyInvitationsProps, IMyInvitationsState>{

      constructor(props:IMyInvitationsProps){
        super(props);
        // set initial state
        this.state = this.getInitState();
        // tslint:disable-next-line:no-unused-expression
        new Ajax('/event/getList', 'POST', { invitationMode: true }, (data:Array<IEventForList>) => {
            var items:Array<IUserItem> = [];
            for (var key in data) {
                var item = data[key];
                if ( item.invitedStatus === null ) {
                    items.push({
                        id: item.id,
                        name: item.name + ' >>',
                        img: item.headerImage,
                        affinity: Tools.dateTimeDistanceFormatter(item),
                        address: item.address,
                        link: '/esemenyek/' + item.id
                    });
                }
            }

            this.setState({
                items : items
            });
        });
    }


    protected getInitState():any{
        return {
            items: []
        };
    }

    render() {
        return (
            <SharedCompUserList editMode={false} title="Meghívásaim" emptyText="Nincsenek meghívásai!" userList={ this.state.items} />
        );
    }
}
export class InitMyInvitations {
    constructor() {
        var div: HTMLDivElement = document.getElementById('my_invitations_comp') as HTMLDivElement;
        if (div !== null) {
           ReactDOM.render(<MyInvitations  />, div);
        }
    }
}





// WEBPACK FOOTER //
// ./components/event/MyInvitations.tsx